<template>
    <div class="nsocComponent nsocComponent__white">
      <h2 class="nsocComponent__title text-center">
        Sit back & Relax, We got our EYES on it. <br />
        <router-link to="/global-nsoc" class="nsocComponent__white">NSOC 24X7</router-link>
      </h2>
      <router-link to="/global-nsoc">
        <img
          src="/images/JFZsxJB.jpg"
          alt="bigbanner-background"
          class="banner-img mt-5"
        />
      </router-link>
    </div>
  </template>
  
  <script>
  export default {
    name: 'GlobalNsocComponent',
  };
  </script>
  
  <style scoped>
  .nsocComponent {
    font-size: 2rem; 
    position: relative;
    z-index: 1;
  }
  
  .nsocComponent__white {
    color: #FBFCF6; 
  }
  
  .nsocComponent__title {
    width: 100%;
    font-size: 4rem;
    position: absolute;
    top: 55vh;
    background: rgba(0, 0, 0, 0.5); 
  
    
    @media (max-width: 1024px) {
      top: 50vh;
      font-size: 3.2rem;
    }
  
    @media (max-width: 768px) {
      top: 20vh;
      font-size: 2.2rem;
    }
  
    @media (max-width: 480px) {
      top: 18vh;
      font-size: 1.1rem;
    }
  }
</style>
  